export default class CtxTexture{
    constructor(url){
        this.img = new Image();
        this.ratio = 1;
        this.ready = false;
        this.img.onload = () => {
            this.ready = true;
            this.ratio = this.img.height / this.img.width;
        }
        this.img.src = url; 
    }

    draw(ctx, w){
        let h = w * this.ratio;
        ctx.drawImage(this.img,-w/2,-h/2, w, h);
    }
}